import angular from 'angular';
import discountRateInput from './discountRateInput';

export default angular
  .module('components.discountRateInput', [])
  .component('discountRateInput', discountRateInput).name;
